// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ShieldOutlinedSvg from "@fishx/icons-svg/es/asn/ShieldOutlined";
import FishxIcon from '../components/FishxIcon';

var ShieldOutlined = function ShieldOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: ShieldOutlinedSvg
  }));
};

ShieldOutlined.displayName = 'ShieldOutlined';
export default React.forwardRef(ShieldOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/ShieldOutlined.js
// module id = 4100
// module chunks = 0